import { render, staticRenderFns } from "./clean.vue?vue&type=template&id=43050ea2&scoped=true&"
import script from "./clean.vue?vue&type=script&lang=ts&"
export * from "./clean.vue?vue&type=script&lang=ts&"
import style0 from "./clean.vue?vue&type=style&index=0&id=43050ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43050ea2",
  null
  
)

export default component.exports